import i18n from '@/lang/vue-18n';
import {ApprovalStatus} from '@/types';

export default class PaperStatus {
    static readonly DRAFT = new PaperStatus('draft', 'blue');
    static readonly UNAPPROVED = new PaperStatus('unapproved', 'orange');
    static readonly SUBMITTED = new PaperStatus('submitted', 'green');
    static readonly UNKNOWN = new PaperStatus('unknown', 'gray');

    private static readonly VALUES = [PaperStatus.DRAFT, PaperStatus.UNAPPROVED, PaperStatus.SUBMITTED];

    static parse(name: ApprovalStatus): PaperStatus {
        return PaperStatus.VALUES.find(s => s.name == name) || PaperStatus.UNKNOWN;
    }

    public style: string[]

    private constructor(public readonly name: string, public readonly color: string) {
        this.style = [`bg-${color}-100`, `text-${color}-800`];
    }

    public translateName(): string {
        return i18n.global.t(`paper_status.${this.name}`);
    }
}
